const {parseAgreementTags} = require("../shared/utils/parse-agreement-tags");

UTIL.registerTask('checkout', 'index', function () {
    (function ($) {

        var vue = new Vue({
            el: 'body',
            created: function() {
                if (ab.requires_action) {
                    $("body").addClass("modal-open");
                    this.start3DSecureAuthentication()
                }
                this.setUpStripe();

                this.setUpFormValidation();
                this.setUpStripeValidation();
                this.setUpLicenses();
            },
            ready: function() {
                this.renderRecaptcha();
            },
            data: {
                seller: ab.seller,
                stripePk: ab.stripe_pk,
                stripe: null,
                card: null,
                cardExpiry: null,
                cardCvc: null,
                stripeRequestAddress: ab.stripeRequestAddress,
                panels: ['details', 'licenses', 'payment'],
                currentPanel: 'details',
                currentLicense: null,
                modalLicense: null,
                wantsToRegister: false,
                agreedTerms: false,
                loggingIn: false,
                loginError: null,
                paypalLoading: false,
                stripeLoading: false,
                FreeOrderLoading:false,
                paymentMethod: 'paypal',
                buyerLoggedIn: ab.buyerLoggedIn,
                name: '',
                cardholder: '',
                email: '',
                username: '',
                password: '',
                errors: {
                    details: false,
                    licenses: false,
                    stripe: false
                },
                stripe3DSecureAuthFailed: false,
                formValidator: false,
                address: {
                    line_1: '',
                    line_2: '',
                    city: '',
                    zip: '',
                    country: 'US'
                },
                requires_action: ab.requires_action,
                csrfToken: ab.csrfToken,
                payment_intent_id: null,
                order_id: ab.order_id,
                confirmationUrl: ab.stripeConfirmationUrl,
                recaptchaWidget: null,
                licenses: [],
                soundKitsType: 'Sound Packs',
                beatsType: 'Beats'
            },
            computed: {
                showPaymentInProgressModal: function() {
                    return this.requires_action && !this.stripe3DSecureAuthFailed;
                }
            },
            methods: {
                setUpLicenses() {
                    const licenses = []
                    let position = 0

                    ab.licenses.forEach((license) => licenses.push({
                        ...license,
                        position: position++,
                        id: license.id,
                        type: this.beatsType,
                        name: license.name,
                        contract: this.resolveContract(license.contract.clean)
                    }))

                    ab.productPricing.forEach(({ agreement }) => {
                        if (!agreement || licenses.some(license =>
                          license.type === this.soundKitsType
                          && license.id === agreement.id)
                        ) return
                        licenses.push({
                            position: position++,
                            id: agreement.id,
                            type: this.soundKitsType,
                            name: agreement.title,
                            contract: this.resolveAgreement(agreement.agreement_text)
                        })
                    })

                    this.licenses = licenses

                    if (licenses.length > 0) {
                        this.currentLicense = licenses[0];
                    } else {
                        this.panels.splice(1, 1);
                    }
                },
                setUpStripe: function() {

                    if (this.stripePk) {
                        this.stripe = Stripe(this.stripePk);
                        var elements = this.stripe.elements();
                        var options = {
                            style: {
                                base: {
                                    color: '#3a3f51',
                                    lineHeight: '20px',
                                    fontSize: '14px',
                                    '::placeholder': {
                                        color: '#c1c2c6',
                                    },
                                },
                            }
                        }
                        //
                        // if (this.stripeRequestAddress) {
                        //     options.hidePostalCode = true;
                        // }

                        this.card = elements.create('cardNumber', options);
                        this.card.mount('#card-element');
                        this.cardExpiry = elements.create('cardExpiry', options);
                        this.cardExpiry.mount('#card-expiry');
                        this.cardCvc = elements.create('cardCvc', options);
                        this.cardCvc.mount('#card-cvc');
                    }
                },
                prevPanel: function() {
                    for (var i = 0; i < this.panels.length; i++) {
                        if (this.panels[i] == this.currentPanel) {
                            this.currentPanel = this.panels[i - 1];
                            break;
                        }
                    }
                },
                nextPanel: function() {

                    switch (this.currentPanel) {
                        case "details":
                            if (!this.buyerLoggedIn && (this.name.length == 0 || this.email.length == 0)) {
                                this.errors.details = true;
                                return
                            }
                            this.errors.details = false;

                            if (!this.validateDetailsSection()) {
                                return;
                            }

                            break;
                        case "licenses":
                            if (!this.agreedTerms) {
                                this.errors.licenses = true;
                                return
                            }
                            this.errors.licenses = false;
                            break;
                    }

                    for (var i = 0; i < this.panels.length; i++) {
                        if (this.panels[i] == this.currentPanel) {
                            this.currentPanel = this.panels[i + 1];
                            break;
                        }
                    }

                },
                prevLicense: function() {
                    if (this.currentLicense.position > 0) {
                        var newPosition = this.currentLicense.position - 1;
                        this.currentLicense = this.licenses[newPosition];
                        this.licenseScrollToTop();
                    }
                },
                nextLicense: function() {
                    if (this.currentLicense.position + 1 < this.licenses.length) {
                        var newPosition = this.currentLicense.position + 1;
                        this.currentLicense = this.licenses[newPosition];
                        this.licenseScrollToTop();
                    }
                },
                setModalLicense: function(licenseType, licenseId) {
                    this.modalLicense = this.licenses
                      .find((license) => license.type === licenseType && license.id === licenseId)
                },
                login: function () {
                    var vue = this;

                    if (!this.username || !this.password) {
                        this.loginError = 'Please enter both your username and password';
                        return false;
                    }

                    this.loginError = null;
                    this.loggingIn = true;

                    $.post('/login', {
                        username: vue.username,
                        password: vue.password,
                        _token: ab.csrfToken,
                    }).done(function (data) {
                        location.reload();
                    }).fail(function (data) {
                        vue.loginError = 'Login failed, please try again and make sure you are entering the correct details';
                    }).always(function () {
                        vue.loggingIn = false;
                    });

                    return false;
                },
                setPaymentMethod: function(method) {
                    if (!this.validateDetailsSection()) {
                        this.errors.details = true;
                        return;
                    }
                    this.errors.details = false;

                    if (!this.validateLicensesSection()) {
                        this.errors.licenses = true;
                        return;
                    }
                    this.errors.licenses = false;

                    this.paymentMethod = method;

                    if (this.paymentMethod == "paypal") {
                        this.checkoutFormValidated();
                    } else if (this.paymentMethod == "free") {
                        this.checkoutFormValidated();
                    } else {
                        this.showCardPaymentForm();
                    }
                },
                // validateForPaypal: function() {
                //     if (this.validateDetailsSection()) {
                //         this.checkoutFormValidated();
                //     } else {
                //         this.currentPanel = "details";
                //     }
                // },
                validateForStripe: function() {
                    if (!this.validateDetailsSection()) {
                        this.errors.details = true;
                        return;
                    }
                    this.errors.details = false;

                    if (!this.validateLicensesSection()) {
                        this.errors.licenses = true;
                        return;
                    }
                    this.errors.licenses = false;

                    if (this.formValidator && this.formValidator.form() && !this.errors.stripe) {
                        this.checkoutFormValidated();
                    }
                },
                showCardPaymentForm: function() {
                    $(".payment-options").slideUp();
                    $(".card-payment-form").slideDown();

                    if (this.recaptchaWidget === null) {
                        this.renderRecaptcha();
                    }
                },
                hideCardPaymentForm: function() {
                    $(".payment-options").slideDown();
                    $(".card-payment-form").slideUp();
                },
                checkoutFormValidated: function (form) {
                    if (!this.isBuyerLoggedIn()) {
                        return this.showConfirmDetailsDialog();
                    }

                    this.beginPayment();
                },
                showConfirmDetailsDialog: function () {
                    var vue = this;

                    bootbox.dialog({
                        message: '<p>Please confirm your details are correct</p> ' +
                        '<p><strong>Name:</strong> ' + this.name + '</p> ' +
                        '<p><strong>Email Address:</strong> ' + this.email + '</p> ' +
                        '<p>These details must be correct as this is where your order will be sent.</p>',
                        title: "Confirm Details",
                        buttons: {
                            danger: {
                                label: "Edit Details",
                                className: "btn-default",
                                callback: function() {
                                    vue.currentPanel = 'details';
                                }
                            },
                            main: {
                                label: "My Details Are Correct",
                                className: "btn-primary",
                                callback: vue.beginPayment
                            }
                        }
                    });
                },
                beginPayment: function () {
                    if (this.isPayPal()) {
                        return this.startPayPalPayment();
                    } else if (this.isFree()) {
                        return this.startFreePayment();
                    } else if (this.isStripe()) {
                        return this.executeRecaptcha();
                    }
                },
                startFreePayment: function () {
                     this.FreeOrderLoading = true;
                    $('#checkout-form').get(0).submit();
                },
                startPayPalPayment: function () {
                    this.paypalLoading = true;
                    $('#checkout-form').get(0).submit();
                },
                startStripePayment: function () {
                    this.stripeLoading = true;
                    var vm = this;

                    var options = {
                        // address_zip: this.address.zip,
                        name : this.cardholder,
                        address: {
                            postal_code: this.address.zip
                        }
                    };

                    if (this.stripeRequestAddress) {
                        options.address.line1 = this.address.line_1,
                            options.address.line2 = this.address.line_2,
                            options.address.city = this.address.city,
                            options.address.country = this.address.country
                    }

                    this.stripe.createPaymentMethod('card', this.card, {billing_details: options}).then(function (result) {
                        if (result.error) {
                            vm.stripeLoading = false;
                            // Inform the user if there was an error
                            vm.errors.stripe = result.error.message;
                            vm.resetRecaptcha();
                        } else {
                            // Send the token to your server
                            vm.stripeResponseHandler(result.paymentMethod);
                        }
                    });
                },
                stripeResponseHandler: function (token) {
                    var form = document.getElementById('checkout-form');
                    var hiddenInput = document.createElement('input');
                    hiddenInput.setAttribute('type', 'hidden');
                    hiddenInput.setAttribute('name', 'stripeToken');
                    hiddenInput.setAttribute('value', token.id);
                    form.appendChild(hiddenInput);

                    // Submit the form
                    form.submit();

                },
                start3DSecureAuthentication: function () {
                    this.stripe = Stripe(this.stripePk);
                    var vm = this;
                    this.stripe.handleCardAction(
                        ab.payment_intent_client_secret
                    ).then(function(result) {
                        if (result.error) {
                            const errorMsg = result.error.message;
                            vm.stripeLoading = false;
                            // Inform the user if there was an error
                            vm.errors.stripe = errorMsg;
                            vm.stripe3DSecureAuthFailed = true;
                            swal({
                                title: "Something went wrong!",
                                text: errorMsg,
                                type: "error",
                                button: "Okay",
                            });
                        } else {
                            var confirmationForm = document.getElementById('confirmationForm');
                            var hiddenInput = document.createElement('input');
                            hiddenInput.setAttribute('type', 'hidden');
                            hiddenInput.setAttribute('name', 'payment_intent_id');
                            hiddenInput.setAttribute('value', result.paymentIntent.id);
                            confirmationForm.appendChild(hiddenInput);
                            confirmationForm.submit();
                        }
                    });
                },
                displayIntegerTerm: function (term) {
                    switch (term) {
                        case -1 :
                            return "Unlimited"
                        case 0 :
                            return "None"
                        default :
                            return term
                    }
                },
                termsEntered: function (license) {
                    if (license) return license.distribution != 0;

                    return false
                },
                isFree: function () {
                    return this.paymentMethod == 'free';
                },
                isPayPal: function () {
                    return this.paymentMethod == 'paypal';
                },
                isStripe: function () {
                    return this.paymentMethod == 'stripe';
                },
                isSellerAllowingLogin: function () {
                    return this.seller.allowCustomerLogin;
                },
                isBuyerLoggedIn: function () {
                    return ab.buyerLoggedIn;
                },
                resolveContract (contract) {
                    return contract?.replace(/%MFS_ORDER_DATE%/g, moment().format('Do MMMM YYYY'))
                        .replace(/%ORDER_DATE%/g, moment().format('Do MMMM YYYY'))
                        .replace(/%MFS_CLIENT_NAME%/g, this.name)
                        .replace(/%CLIENT_NAME%/g, this.name)
                        .replace(/%MFS_BEAT_NAME%/g, 'BEAT NAME')
                        .replace(/%BEAT_NAME%/g, 'BEAT NAME')
                },
                resolveAgreement (agreement) {
                    return parseAgreementTags(agreement)
                },
                licenseScrollToTop: function() {
                    $("#current-license").scrollTop(0);
                },
                setUpFormValidation: function() {
                    this.formValidator =  $("#checkout-form").validate({
                        rules: {
                            name: "required",
                            cardholder: "required",
                            email: {
                                required: true,
                                email: true

                            },
                            "address[line_1]": "required",
                            "address[city]": "required",
                            "address[code]": "required",
                            "address[country]": "required"
                        },
                        messages: {
                            name: "Please enter a name",
                            cardholder: "Please enter the cardholder name",
                            email: {
                                required: "Please enter an email address",
                                email: "Please enter a valid email address"
                            },
                            "address[line_1]": "Please enter your street address",
                            "address[city]": "Please enter your city",
                            "address[code]": "Please enter your post/zip code",
                            "address[country]": "Please select your country"
                        },
                        submitHandler: function (form) {
                            vue.checkoutFormValidated(form);

                            return false;
                        },
                    });
                },
                setUpStripeValidation: function() {
                    var vm = this;

                    if (this.card) {
                        this.card.addEventListener('change', function (event) {
                            vm.throwStripeError(event.error);
                        });
                    }
                    if (this.cardExpiry) {
                        this.cardExpiry.addEventListener('change', function (event) {
                            vm.throwStripeError(event.error);
                        });
                    }
                    if (this.cardCvc) {
                        this.cardCvc.addEventListener('change', function(event) {
                            vm.throwStripeError(event.error);
                        });
                    }

                },
                throwStripeError: function(error) {
                    if (error) {
                        this.errors.stripe = error.message;
                    } else {
                        this.errors.stripe = false;
                    }
                },
                validateDetailsSection: function() {
                    if (!this.buyerLoggedIn && this.formValidator) {
                        if (!this.formValidator.element("#name") || !this.formValidator.element("#email")) {
                            return false;
                        };
                    }

                    return true;
                },
                validateLicensesSection: function() {
                    if (this.licenses.length > 0 && !this.agreedTerms) {
                        return false;
                    }

                    return true;
                },
                renderRecaptcha: function() {
                    if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {

                        var vm = this;
                        this.recaptchaWidget = window.grecaptcha.render('g-recaptcha', {
                            size: 'invisible',
                            // the callback executed when the user solves the recaptcha
                            callback: function(response) {
                                vm.startStripePayment();
                            }
                        });
                    }
                },
                executeRecaptcha: function() {
                    window.grecaptcha.execute(this.recaptchaWidget);
                },
                resetRecaptcha: function() {
                    // reset the recaptcha widget so you can execute it again
                    window.grecaptch.reset(this.recaptchaWidget);
                }
            },
            watch: {
                showPaymentInProgressModal: function(show) {
                    if(show)
                        $("body").addClass("modal-open");
                    else
                        $("body").removeClass("modal-open");
                },
                agreedTerms: function(newVal, oldVal) {
                    if (newVal == true) {
                        this.errors.licenses = false;
                    } else if (newVal == false) {
                        this.hideCardPaymentForm();
                    }
                },
                wantsToRegister: function (newVal, oldVal) {
                    if (newVal == true) {
                        $("input[name=email]").rules('add', {
                            remote: {
                                url: ab.authCheckUrl,
                                type: "post",
                                data: {
                                    _token: ab.csrfToken
                                }
                            },
                            messages: {
                                remote: 'This email address is already taken. If you own this account, please login'
                            }
                        });
                    } else {
                        $("input[name=email]").rules('remove', 'remote');
                    }
                },
            }
        })

        $('#cc-number').payment('formatCardNumber');
        $('#cc-exp').payment('formatCardExpiry');
        $('#cc-cvc').payment('formatCardCVC');

    })(jQuery);
});
